import { ViewChild, Component, ElementRef } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { PNMaps } from '../../pan.maps';
import { DIC } from '../dic';
import { GN } from '../../gn';
// import { PN } from '../../pan';

@Component({
  selector: 'page-addpoi',
  templateUrl: 'addpoi.html',
})
export class AddpoiPage {
  @ViewChild('mapPOI') mapElement: ElementRef;

  namePOI: any = '';
  radius: any = 50;
  avaliable: any = 1;
  Groups = []
  _groupID = '1'
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public panMaps: PNMaps, public dic: DIC, public alertCtrl: AlertController, public pan: GN, public toastCtrl: ToastController) {
    this.panMaps.mapPOI = null
    this.panMaps.isPozWatching = false
    this.panMaps.isMyPozOK = false
  }

  ionViewDidLoad() {
    this.loadPoiGroups()


    // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition(function (_poz) {
    //     console.log(_poz.coords)
    //   });
    // } else {
    //   //x.innerHTML = "Geolocation is not supported by this browser.";
    //   console.log("Geolocation is not supported by this browser.")
    // }
  }

  loadPoiGroups() {
    var _that = this
    this.pan._Post('/api/gn/getpoigroups', { cid: this.pan.crypt(this.pan.user.ClientId) }, function (_data) {
      _data[0].name = _that.dic.l["Ungroupped"]
      _that.Groups = _data

      console.log('ionViewDidLoad AddpoiPage');
      _that.panMaps.loadMapPOI(_that.mapElement.nativeElement, function () {
        _that.panMaps.drawCircle1(_that.radius);
      })
    })
  }

  changeRadius(_rad: any) {
    this.radius = _rad;
    this.panMaps.drawCircle1(this.radius);

  }


  getLocationUser() {
    var _that = this;
    console.log('getLocationUser')
    this.panMaps.loadMapPOI(this.mapElement.nativeElement, function () {
      console.log('vleze vo getLocationUser')
      _that.panMaps.drawCircle1(_that.radius);
      // _that.getLocationUser2()
    })
  }

  getLocationUser2() {
    var _that = this;
    this.panMaps.loadMapPOI(this.mapElement.nativeElement, function () {
      _that.panMaps.drawCircle1(_that.radius);
    })
  }

  setAvalFor(_av: any) {
    this.avaliable = _av;
  }


  addPOI() {
    var _that = this;
    if (this.panMaps.isMyPozOK == false) {
      const toast = this.toastCtrl.create({
        message: _that.dic.l['locationserviceerror'],
        duration: 3000,
        position: 'top'
      });
      toast.present();
      return
    }

    if (this.namePOI.length == 0) {
      var alert = this.alertCtrl.create({
        title: this.dic.l['Warning'],
        subTitle: this.dic.l['EmptyNamePOI'],
        buttons: ['OK']
      });
      alert.present();
    }
    else {
      console.log(this.namePOI, this.radius, this.avaliable)
      var lat = this.panMaps.pinMarker.getPosition().lat();
      var lon = this.panMaps.pinMarker.getPosition().lng();
      console.log(lat, lon, this.pan.user.UserId, this.pan.user.ClientId)

      this.pan._Post('/api/insertPOImobile', {
        name: this.pan.crypt(this.namePOI),
        radius: this.pan.crypt(this.radius),
        avaliable: this.pan.crypt(this.avaliable),
        lat: this.pan.crypt(lat),
        lon: this.pan.crypt(lon),
        uid: this.pan.crypt(this.pan.user.UserId),
        cid: this.pan.crypt(this.pan.user.ClientId),
        groupid: this.pan.crypt(this._groupID)
      }, function (_data) {
        const toast = _that.toastCtrl.create({
          message: _that.dic.l[_data.msg],
          duration: 3000,
          position: 'top'
        });
        toast.present();
        if (_data.msg == 'success-add-poi') {
          _that.navCtrl.pop();
        }
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/addpoi/addpoi.ts